import isEqual from 'lodash.isequal';
import { useEffect, useState } from 'react';
import { NO_AXIS_SELECTED_VALUE } from './constants';
import { getDataRequestedConfig } from './getDataRequestedConfig';
import type { Chart } from './types';

export const useRequestConfig = <T extends Chart>(config: T) => {
  const [requestConfig, setRequestConfig] = useState(
    getDataRequestedConfig(config),
  );

  useEffect(
    () => {
      const newRequestConfig = getDataRequestedConfig(config);

      if (config.secondaryMetric === NO_AXIS_SELECTED_VALUE) {
        const { secondaryMetric, ...cleanedRequestedConfig } = requestConfig;
        const { secondaryMetric: _, ...cleanedNewRequestConfig } =
          newRequestConfig;

        if (!isEqual(cleanedRequestedConfig, cleanedNewRequestConfig)) {
          setRequestConfig(newRequestConfig);
        }
      } else if (!isEqual(requestConfig, newRequestConfig)) {
        setRequestConfig(newRequestConfig);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config],
  );

  return requestConfig;
};
